export const RESTFULL_API_URL = `https://medpro-api-v3-testing.medpro.com.vn`;

export const DOMAIN_SHARE_URL = `https://testing.medpro.com.vn`;

export const MEDPRO_LOGIN = `https://id-testing.medpro.com.vn/check-phone`; // medpro-id v1.2

export const STATIC_CONTENT_API_URL = `https://static-inside-testing.medpro.com.vn`;

export const COOKIE_EXPIRES = 43200; // 12*60*60; // 12 tiếng

export const SOCKET_CHAT = "wss://socket.pkh.vn/cable";

export const PAYMENT_HUB_URL =
  "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const CSKH_API_URL = "https://103.48.193.51:8080";

export const BO_WEB = "http://localhost:4300";

export const MEDPRO_WEB = "https://testing.medpro.com.vn";
